/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelBrokerageWorkflowNextStatus.ts   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/brokerage-workflow-next-status";

export class AutogenModelBrokerageWorkflowNextStatus<RowType extends ModelRow> extends Endpoint<RowType, RowBrokerageWorkflowNextStatusFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowBrokerageWorkflowNextStatus extends ModelRow<RowBrokerageWorkflowNextStatusFields> {
	constructor(values?: Partial<RowBrokerageWorkflowNextStatusFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowBrokerageWorkflowNextStatusFields {
	company_id: string;
	descr: string;
	display_callin_screen: string;
	display_portal: string;
	id: string;
	is_active: string;
	is_enabled: boolean;
	movement_status: string;
	planning_color: number;
	brokerage_status_code: string;
	can_be_changed_to: string;
}

